import { Link } from "react-router-dom";

export function ProductCard({
  id,
  imageData,  
  name,
  price,
  altText,
  stock,
}) {
  return (
    <div className="border p-4 rounded-md shadow-lg flex flex-col justify-between items-center mx-auto w-full mb-[26px]">
      <Link to={`/product/${id}`} className="hover:opacity-90 transition w-full">
        <div className="w-full rounded-lg overflow-hidden">
          
          {imageData?.type === 'optimized' ? (
            <picture className="block w-full h-full">
              <source type="image/avif" srcSet={imageData.avif} />
              <source type="image/webp" srcSet={imageData.webp} />
              <img
                src={imageData.webp}
                alt={altText || name}
                loading="lazy"
                decoding="async"
                fetchpriority="low"
                className="w-full h-full object-cover"
              />
            </picture>
          ) : imageData?.type === 'original' ? (
            <img
              src={imageData.url}
              alt={altText || name}
              loading="lazy"
              decoding="async"
              fetchpriority="low"
              className="w-full h-full object-cover rounded-lg"
            />
          ) : (
            <div className="w-full h-64 bg-gray-200 flex items-center justify-center rounded-lg">
              <span className="text-gray-400">No image</span>
            </div>
          )}
          
        </div>

        <h3 className="text-lg font-semibold text-center mt-4">{name}</h3>
        <p className="text-md font-light text-center mt-2">
          {Number(price).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
        </p>
        <p
          className={`text-sm mt-2 ${stock === 0 ? 'text-red-500' : stock < 5 ? 'text-orange-500' : 'text-green-600'}`}
        >
          {stock > 0 ? `${stock} in stock` : 'Out of stock'}
        </p>
      </Link>
    </div>
  );
}
